export const topbarDialogPosition = {
  top: '48px',
  right: '16px',
};
